import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PRODUCT_QUERY_KEY } from './useGetProduct';
import { GET_PRODUCTS_QUERY_KEY } from './useGetProducts';

import ProductsService, {
  UpdateToneOfVoiceDto,
} from '@/services/ProductsService';

export function useUpdateToneOfVoice() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (updateToneOfVoiceDto: UpdateToneOfVoiceDto) =>
      ProductsService.updateToneOfVoice(updateToneOfVoiceDto),
    onSuccess: async (data) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: GET_PRODUCTS_QUERY_KEY(),
        }),
        data.map((response) =>
          queryClient.invalidateQueries({
            queryKey: GET_PRODUCT_QUERY_KEY(response.id),
          }),
        ),
      ]);
    },
  });

  return {
    updateToneOfVoice: mutateAsync,
    isLoading: isPending,
  };
}
